import React, { useState, Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import { LineBoxContainer } from "../../../../pages/UserLog/UserLog";
import CalendarLineBtn from "../../../Button/CalendarLineBtn";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import LineBtn from "../../../Button/LineBtn";
import FilterIcon from "../../../DefaultStyles/FilterIcon";
import Flex from "../../../DefaultStyles/Flex";
import CalendarModal from "../../../Modal/CalendarModal";
import ToolTip from "../../../Modal/ToolTip";
import { SectionFilterContainer } from "../../AlimTalk/AlimTalkFilter";
import { CalendarLine } from "../../Party/ChatInfo/ChatSearch/RecentChat";

interface LmsFilterProps {
  setFilter: any;
  setPage: Dispatch<SetStateAction<number>>;
}

export default function LmsFilter({ setFilter, setPage }: LmsFilterProps) {
  const [startDate, setStartDate] = useState("날짜 선택");
  const [startDateClick, setStartDateClick] = useState(false);
  const [endDate, setEndDate] = useState("날짜 선택");
  const [endDateClick, setEndDateClick] = useState(false);

  return (
    <SectionFilterContainer>
      <Flex gapSize={10}>
        <FilterIcon maxWidth={1150} />

        <ToolTip direction="top" msg="한번에 최대 7일까지 조회 가능" />

        <LineBoxContainer>
          <CalendarLineBtn
            onClickEvent={() => setStartDateClick(true)}
            value={startDate}
            initValue={"날짜 선택"}
            minWidth={155}
          />

          {startDateClick && (
            <CalendarModal
              closeEvent={() => setStartDateClick(false)}
              changeEvent={(date: string) => setStartDate(date)}
              isFutureDisable={true}
            />
          )}
        </LineBoxContainer>

        <CalendarLine />

        <LineBoxContainer>
          <CalendarLineBtn
            onClickEvent={() => setEndDateClick(true)}
            value={endDate}
            initValue={"날짜 선택"}
            minWidth={155}
            disabled={startDate === "날짜 선택"}
          />

          {endDateClick && (
            <CalendarModal
              closeEvent={() => setEndDateClick(false)}
              changeEvent={(date: string) => setEndDate(date)}
              dateValue={startDate}
              isAfter={{
                value: 7,
                unit: "day",
              }}
            />
          )}
        </LineBoxContainer>

        <ConfirmBtn
          btnText="적용"
          btnColor="mint"
          btnHeight={38}
          btnClickEvent={() => {
            setPage(0);
            setFilter({
              startDate: startDate !== "날짜 선택" ? startDate : "",
              endDate: endDate !== "날짜 선택" ? endDate : "",
            });
          }}
        />

        <LineBtn
          btnText="초기화"
          btnColor="mint"
          icon="refresh"
          btnHeight={38}
          btnClickEvent={() => {
            setStartDate("날짜 선택");
            setEndDate("날짜 선택");
            setFilter({
              startDate: "",
              endDate: "",
            });
          }}
        />
      </Flex>
    </SectionFilterContainer>
  );
}
